import { fileUrl, formatSeconds } from "@/lib/api";

export default function ECertificate({ registration, eventName = "ALLIED VIRTUAL RUN", backgroundPath, sponsorLogos = [] }) {
  if (!registration) return null;
  const cert = registration.certificate_data || {};
  return (
    <div
      id={`ecert-${registration.id}`}
      className="relative w-[900px] max-w-full aspect-[1.414/1] bg-[#0A0A0A] text-white overflow-hidden"
      style={{
        boxShadow: "inset 0 0 0 8px #0A0A0A, inset 0 0 0 9px #FF3B30, inset 0 0 0 20px #0A0A0A, inset 0 0 0 21px #27272A",
      }}
      data-testid="ecert-render"
    >
      {backgroundPath && (
        <>
          <img src={fileUrl(backgroundPath)} alt="" crossOrigin="anonymous" className="absolute inset-0 w-full h-full object-cover opacity-40" />
          <div className="absolute inset-0 bg-black/50" />
        </>
      )}
      <div className="absolute inset-0 grain" />
      <div className="relative h-full px-14 py-12 flex flex-col">
        <div className="flex items-center justify-between">
          <div>
            <div className="text-[10px] tracking-[0.4em] text-white/50 font-display">{eventName}</div>
            <div className="text-[10px] tracking-[0.3em] text-[#FF3B30] font-display">CERTIFIED FINISHER</div>
          </div>
          <div className="text-right font-mono-num text-xs text-white/60">
            BIB · <span className="text-white">{registration.bib_number}</span>
          </div>
        </div>

        <div className="mt-8">
          <div className="font-display text-4xl tracking-wider text-white">{cert.certificate_title || "CERTIFICATE OF COMPLETION"}</div>
          <div className="mt-2 text-sm text-white/60 tracking-widest uppercase">{cert.certificate_subtitle || "This is proudly presented to"}</div>
        </div>

        <div className="mt-6">
          <div className="font-display text-5xl tracking-wide text-[#FF3B30]">
            {registration.full_name?.toUpperCase()}
          </div>
          <div className="mt-1 text-sm text-white/60 tracking-widest">
            {registration.city?.toUpperCase()} · {registration.category_name}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-3 gap-6">
          <div className="border-l-2 border-[#FF3B30] pl-4">
            <div className="text-[10px] tracking-widest text-white/50 font-display">DISTANCE</div>
            <div className="font-display text-2xl">{registration.result_distance_km || registration.category_distance_km}<span className="text-sm text-white/60"> KM</span></div>
          </div>
          <div className="border-l-2 border-[#FF3B30] pl-4">
            <div className="text-[10px] tracking-widest text-white/50 font-display">FINISH TIME</div>
            <div className="font-display text-2xl font-mono-num">{formatSeconds(registration.result_time_seconds)}</div>
          </div>
          <div className="border-l-2 border-[#FF3B30] pl-4">
            <div className="text-[10px] tracking-widest text-white/50 font-display">DATE</div>
            <div className="font-display text-2xl">{(registration.result_submitted_at || registration.created_at || "").slice(0, 10)}</div>
          </div>
        </div>

        <div className="mt-auto">
          {sponsorLogos.length > 0 && (
            <div className="mb-5 flex items-center gap-5" data-testid="cert-sponsors">
              <div className="text-[10px] tracking-[0.3em] text-white/40 font-display">SUPPORTED BY</div>
              {sponsorLogos.map((l, i) => (
                <img key={i} src={fileUrl(l)} alt="" crossOrigin="anonymous" className="h-7 object-contain opacity-90" />
              ))}
            </div>
          )}
          <div className="flex items-end justify-between">
          <div className="max-w-md">
            <div className="text-xs text-white/50 tracking-widest uppercase">{cert.footer_text || "Congratulations on completing your run!"}</div>
          </div>
          <div className="text-right">
            <div className="font-display text-lg text-white">{cert.signature_name || "Race Director"}</div>
            <div className="border-t border-white/30 pt-1 text-[10px] tracking-widest text-white/60 uppercase">
              {cert.signature_title || "Committee"}
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  );
}
